import {
  Alert,
  Box,
  LinearProgress,
  Paper,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { useState } from "react";
import ReactQuill from "react-quill";
import { useHistory } from "react-router";
import Admin from "../../../Pages/Admin";
import usePostData from "../../../utility/usePostData";
import "react-quill/dist/quill.snow.css";

const AnnonceAdd = () => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const { error, submitData, isLoading } = usePostData();
  const history = useHistory();
  const saveData = (e) => {
    e.preventDefault();

    if (title === "" || body === "") {
      alert("completer tout les champs");
      return false;
    }
    const x = { title, body };
    submitData("annonces", x);

    history.push("annonce");
  };
  return (
    <Admin>
      <Box sx={{ width: "90%", margin: "auto", mt: 4 }}>
        <Paper elevation={2} sx={{ p: 4, borderRadius: 2 }}>
          <Typography
            variant="h5"
            sx={{
              color: "#00a652",
              mb: 4,
              fontWeight: 500,
              borderBottom: "2px solid #00a652",
              paddingBottom: 1,
              display: "inline-block",
            }}
          >
            Nouvelle Annonce
          </Typography>

          <form onSubmit={saveData}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <TextField
                label="Titre"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": {
                      borderColor: "#00a652",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#00a652",
                    },
                  },
                }}
              />

              <Box sx={{ minHeight: "300px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    mb: 1,
                    color: "text.secondary",
                  }}
                >
                  Description
                </Typography>
                <ReactQuill
                  theme="snow"
                  value={body}
                  onChange={setBody}
                  style={{ height: "250px" }}
                />
              </Box>

              {isLoading && (
                <LinearProgress
                  sx={{
                    backgroundColor: "#e0e0e0",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#00a652",
                    },
                  }}
                />
              )}

              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {JSON.stringify(error)}
                </Alert>
              )}

              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<SaveIcon />}
                  sx={{
                    backgroundColor: "#00a652",
                    "&:hover": { backgroundColor: "#008c46" },
                    px: 4,
                  }}
                >
                  Enregistrer
                </Button>
              </Box>
            </Box>
          </form>
        </Paper>
      </Box>
    </Admin>
  );
};

export default AnnonceAdd;
